import { render, staticRenderFns } from "./jzbg.vue?vue&type=template&id=1b2b0cde&scoped=true"
import script from "./jzbg.vue?vue&type=script&lang=js"
export * from "./jzbg.vue?vue&type=script&lang=js"
import style0 from "./jzbg.vue?vue&type=style&index=0&id=1b2b0cde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2b0cde",
  null
  
)

export default component.exports